// src/pages/Login.js
import React from 'react';
import { Box, TextField, Button, Typography, Card, CardContent } from '@mui/material';

const Login = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',  // Center horizontally
        alignItems: 'center',      // Center vertically
        height: '100vh',           // Full viewport height
        bgcolor: '#f0f2f5',        // Light background color
        padding: '2rem',           // Outer padding
      }}
    >
      <Card
        sx={{
          width: '100%',
          maxWidth: '400px',        // Maximum width for the form
          borderRadius: '16px',     // Rounded corners
          boxShadow: 3,             // Subtle shadow effect
        }}
      >
        <CardContent>
          <Typography
            variant="h4"
            align="center"
            sx={{
              fontWeight: 'bold',
              marginBottom: '1.5rem',
              color: '#2c3e50',      // Darker text for contrast
            }}
          >
            Admin Login
          </Typography>
          <TextField
            label="Username"
            variant="outlined"
            sx={{
              marginBottom: '1rem',
              width: '100%',
              borderRadius: '8px',  // Rounded corners for the text field
            }}
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            sx={{
              marginBottom: '1.5rem',
              width: '100%',
              borderRadius: '8px',  // Rounded corners for the text field
            }}
          />
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{
              borderRadius: '8px',  // Rounded corners for the button
              padding: '0.8rem',    // Padding for the button
              '&:hover': {
                backgroundColor: '#0069d9',  // Darker hover effect
              },
            }}
          >
            Login
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Login;
